<template>
  <div
    class="line"
  >
    <Table
      :columns="columns"
      :data="list"
      size="small"
    >
      <div
        slot="header"
        style="padding: 6px; text-align: center; font-weight: bold;"
      >
        配件详情
      </div>
    </Table>
  </div>
</template>
<script>
  export default {
    props: {
      list: {
        type: Array
      }
    },
    computed: {
      columns() {
        return [
          {
            title: '配件代码',
            align: 'center',
            key: 'uid',
            render(h, {row}) {
              return h('span', {}, row.stock.uid)
            }
          },
          {
            title: '配件名称',
            align: 'center',
            key: 'name',
            render(h, {row}) {
              return h('span', {}, row.stock.name)
            }
          }, {
            title: '采购数量',
            align: 'center',
            key: 'qty',
            render(h, {row}) {
              return h('span', {}, Util.formattingNumber(row.qty))
            }
          }, {
            title: '采购单价',
            align: 'center',
            
            render:(h, {row}) => {
              return h('span', {}, '测试')
            }
          }, {
            title: '采购总价',
            align: 'center',
            key: 'total_price',
            
          }, {
            title: '配件用量',
            align: 'center',
            key: 'unit_qty',
            
          }, {
            title: '备注',
            align: 'center',
            key: 'remark',
            
          },
        ]
      }
    }
  }
</script>